import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21 2.932h-3.5L15.8.39C15.6.195 15.3 0 15 0H9c-.3 0-.6.195-.8.39L6.5 2.932H3c-1.7 0-3 1.27-3 2.933v10.753c0 1.662 1.3 2.933 3 2.933h18c1.7 0 3-1.271 3-2.933V5.865c0-1.662-1.3-2.933-3-2.933m1 13.686c0 .587-.4.978-1 .978H3c-.6 0-1-.391-1-.978V5.865c0-.587.4-.978 1-.978h4c.3 0 .6-.195.8-.39l1.7-2.543h4.9l1.7 2.542c.3.196.6.391.9.391h4c.6 0 1 .391 1 .978zM12 5.865c-2.8 0-5 2.15-5 4.888s2.2 4.888 5 4.888 5-2.151 5-4.888-2.2-4.888-5-4.888m0 7.82c-1.7 0-3-1.27-3-2.932s1.3-2.933 3-2.933 3 1.27 3 2.933-1.3 2.932-3 2.932"
    }, null, -1)
  ]))]))
}
export default { render: render }